import { watch } from 'vue'

import { useTrendSeasonalityStore } from '../stores/trendSeasonalityStore'

import { useWorkspace } from '@/features/account'
import { registerSessionReset } from '@/features/auth'

/** Full `reset()` on both edges rather than `clearData()`: the search box and the tab/period
 *  toggles are chrome, but `filters` holds `ReportFilter` values drawn from the previous
 *  workspace's dimensions — carrying those into the next tenant would filter its keywords by
 *  values that do not exist there. */
export function registerMarketingInsightsLifecycle(): () => void {
  const store = useTrendSeasonalityStore()
  const { workspaceId } = useWorkspace()
  const stopWorkspace = watch(
    workspaceId,
    (next, previous) => {
      if (String(next ?? '') !== String(previous ?? '')) store.reset()
    },
    { flush: 'sync' },
  )
  const unregisterSession = registerSessionReset(() => store.reset())
  return () => {
    stopWorkspace()
    unregisterSession()
  }
}
